import React from 'react';
import { CalendarDays } from 'lucide-react';
import { fmtBRL, fmtDate } from './organization';

export const discountLabel = title => {
  // Somente formatação. O valor monetário e o percentual vêm da projeção canônica.
  const amount = fmtBRL(title.desconto);
  const type = String(title.desconto_tipo || title.discount_type || '').toLowerCase();
  const percent = title.desconto_percentual;
  if (['percent', 'percentual', 'percentage', '%'].includes(type) && percent != null) {
    const label = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 20 }).format(percent);
    return `${label}%  (-${amount})`;
  }
  return `-${amount}`;
};

export const TitleValues = ({ title: t, prefix = 'title' }) => (
  <div className="min-w-0 space-y-3">
    <div className={`flex items-center justify-between gap-2 border-b border-slate-100 pb-2 ${t.status === 'vencido' ? 'text-red-700' : 'text-slate-700'}`}>
      <span className="inline-flex items-center gap-1.5 text-xs"><CalendarDays className="h-3.5 w-3.5" />Vencimento</span>
      <span className="text-sm font-semibold tabular-nums text-right" data-testid={`${prefix}-due-${t.view.key}`}>{fmtDate(t.vencimento)}</span>
    </div>
    <dl className="space-y-1.5">
      <div className="flex items-baseline justify-between gap-3 text-xs text-slate-500">
        <dt>Valor nominal</dt><dd className="min-w-0 text-right tabular-nums break-words" data-testid={`${prefix}-nominal-${t.view.key}`}>{fmtBRL(t.valor_original)}</dd>
      </div>
      {t.desconto > 0 && <div className="flex items-baseline justify-between gap-3 text-xs text-emerald-700">
        <dt>Desconto</dt><dd className="min-w-0 text-right font-semibold tabular-nums break-words" data-testid={`${prefix}-discount-${t.view.key}`}>{discountLabel(t)}</dd>
      </div>}
      <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 pt-2">
        <dt className="text-xs font-medium text-slate-600">Valor final</dt><dd className="max-w-full text-2xl font-bold text-slate-900 tabular-nums break-words" data-testid={`${prefix}-final-${t.view.key}`}>{fmtBRL(t.valor_atual)}</dd>
      </div>
    </dl>
  </div>
);